import isEmail from 'validator/lib/isEmail';

export default (email: string) => {
  if (isEmail(email)) return undefined;
  return 'Invalid email.';
};
